import { render } from "./IconQRcode.vue?vue&type=template&id=0549a29b"
import script from "./IconQRcode.vue?vue&type=script&lang=ts"
export * from "./IconQRcode.vue?vue&type=script&lang=ts"
script.render = render

export default script